import {useParams, useSearchParams} from "react-router-dom";
import useCompanyService from "../api/services/useCompanyService";
import {useEffect} from "react";
import cloneDeep from 'lodash/cloneDeep';
import swal from "sweetalert";
import useValidateCoc from "./useValidateCoc";


const useValidationIban = (id, form, callbackUrl) => {
  const companyService = useCompanyService()
  const params = useParams()
  const [searchParams, setSearchParams] = useSearchParams();
  const {onClickValidateCoc} = useValidateCoc(id, form)

  useEffect(() => {
    userValidateIbanCallback()
  }, [params])

  const onClickValidateIban = () => {
    companyService.userValidateIban(
      (data) => {
        if ('url' in data) {
          window.location.href = data.url
        } else {
          throw new Error('Invalid URL in userValidateIban');
        }
      },
      () => {
      },
      id,
      callbackUrl,
    )
  }

  const userValidateIbanCallback = () => {
    const validateIban = searchParams.get("validate_iban")
    if (id && validateIban) {
      companyService.userValidateIbanCallback(
        (company) => {

          console.log('company', company)

          if (company.iban_verified_at && company.iban_verified_at !== 'remove-validation') {
            form.formData.model = company
            form.setOriginalFormDataModel(cloneDeep(company))
            form.save(false)
            searchParams.delete('validate_iban')
            setSearchParams(searchParams);

            swal({
              title: 'Success',
              icon: 'success',
              text: 'IBAN Validatie Gelukt',
              buttons: {
                cancel: {
                  text: "later",
                  value: false,
                  visible: true,
                  className: 'btn-color-grey btn-size-m',
                  closeModal: true,
                },
                confirm: {
                  text: "Stap 2: KvK nummer valideren",
                  value: true,
                  visible: true,
                  className: 'btn-color-green btn-size-m',
                  closeModal: true,
                }
              }
            }).then(result => {
              if (result) {
                onClickValidateCoc()
              }
            })
          } else {
            searchParams.delete('validate_iban')
            setSearchParams(searchParams);
            swal({
              title: 'Error',
              icon: 'error',
              text: 'Validatie Mislukt 1',
              buttons: {
                confirm: {
                  text: "Oke",
                  value: true,
                  visible: true,
                  className: 'btn-color-grey btn-size-m',
                  closeModal: true,
                }
              }
            })
            throw new Error('Validation error')
          }
        },
        () => {
          searchParams.delete('validate_iban')
          setSearchParams(searchParams);
          swal({
            title: 'Error',
            icon: 'error',
            text: 'Validatie Mislukt 2',
            buttons: {
              confirm: {
                text: "Oke",
                value: true,
                visible: true,
                className: 'btn-color-grey btn-size-m',
                closeModal: true,
              }
            }
          })
        },
        id,
        validateIban,
      )
    }
  }

  return {
    onClickValidateIban,
    userValidateIbanCallback,
  }
}

export default useValidationIban
